export class Address {
  latitude: number;
  longitude: number;
  google_place_id: string;
  formated_address: string;
  icon: string;
}
